import { object, string } from 'yup';

export const editTaskDescriptionSchema = object({
  description: string().nullable(),
  priority: string().nullable(),
});
